export default __webpack_public_path__ + "static/media/fb.e23a19ba.svg";